


import './App.css';
import './style.css'
// import './styles/css/aos.css'
import './styles/css/bootstrap.min.css'
import './styles/css/dark-theme.css'
import './styles/css/fancybox.css'
import './styles/css/flaticon.css'
import './styles/css/line-awesome.min.css'
import './styles/css/magnific-popup.css'
import './styles/css/odometre.css'
import './styles/css/responsive.css'
import './styles/css/style.css'
import './styles/css/swiper-min.css'
import './styles/css/slider-fix.css'
import { BrowserRouter as Router, Routes, Navigate, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import HomePage from './Component/HomePage/HomePage';
import FindTutor from './Component/HomePage/FindTutor/FindTutor'
import BecomeTutor from './Component/HomePage/BecomeTutor/BecomeTutor';
import BlogHome from './Component/HomePage/Blog/BlogHome';
import Login from './Component/Authentication/Login/Login';
import Register from './Component/Authentication/Register/Register';
import TutorHome from './Component/TutorModule/TutorDashboard/TutorHome';
import TermsAndCondition from './Component/HomePage/Cms/TermsAndCondition';
import PrivacyPolicy from './Component/HomePage/Cms/PrivacyPolicy';
import ForgetPassword from './Component/Authentication/ForgetPassword/ForgetPassword';
import OtpVerify from './Component/Authentication/OtpVerfy.jsx/OtpVerify';
import ResetPassword from './Component/Authentication/ResetPassword/ResetPassword';

import BlogDetail from './Component/HomePage/Blog/BlogDetail/BlogDetail';
// import ContactPage from './Component/HomePage/Contact/Contact.jsx';

import ScrollToTop from './ScrollToTop';

import StudentHome from './Component/StudentModule/StudentHome/StudentHome';
import AboutUs from './Component/HomePage/AboutUs/AboutUs';
import MeetingFrame from './Component/VideoMeet/MeetingFrame';
import StudentLoginPage from './Component/Authentication/Separate_Login/StudentLogin';
import TutorLoginPage from './Component/Authentication/Separate_Login/TutorLogin';
import StudentRegisterPage from './Component/Authentication/Separate_Register/StudentRegisterPage.jsx';
import TutorRegisterPage from './Component/Authentication/Separate_Register/TutorRegister.jsx';

import GoogleTest from "./pages/GoogleTest.jsx";







function App() {


  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>

          <Route path="student/login" element={<StudentLoginPage />} />
          <Route path="tutor/login" element={<TutorLoginPage />} />
          <Route path="student/register" element={<StudentRegisterPage />} />
          <Route path="tutor/register" element={<TutorRegisterPage />} />

          <Route index element={<HomePage />} />
          <Route path="*" element={<Navigate to="/" />} />


          <Route path="/" element={<HomePage />} />
          {/* <Route path="/contact" element={<ContactPage />} /> */}


          <Route path="tutor/*" element={<TutorHome />} />

          <Route path="student/*" element={<StudentHome />} />
          <Route path="login" element={<Login />} />
          <Route path="register" element={<Register />} />
          <Route path="forget-password" element={<ForgetPassword />} />
          <Route path="otp-verification" element={<OtpVerify />} />
          <Route path="reset-password" element={<ResetPassword />} />

          <Route path="find-tutor" element={<FindTutor />} />
          <Route path="become-tutor" element={<BecomeTutor />} />
          <Route path="blog" element={<BlogHome />} />
          <Route path="blog-detail/:name" element={<BlogDetail />} />
          <Route path="terms-and-conditions" element={<TermsAndCondition />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="about-us" element={<AboutUs />} />
          <Route path='/show-meeting' element={<MeetingFrame />} />

          <Route path="/google-test" element={<GoogleTest />} />

        </Routes>

        <Toaster
          position="top-right"
          reverseOrder={false}
        />

      </div>
    </Router>
  );
}

export default App;
